/* @jsx h */
import { TableOrders } from "@app/vue/components/POSComponent/TableOrders";
import { TableStatus } from "@lemmonhq/types";
import { defineComponent, h } from "vue";

export type TableOverviewProps = {
  tableStatus: TableStatus;
};
export const TableOverview = defineComponent<TableOverviewProps>({
  name: "TableOverview",
  props: ["tableStatus"],
  setup(props) {
    return () => {
      return <TableOrders tableId={props.tableStatus.id} />;
    };
  },
});
